import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { map, includes, remove, concat, get, split, join, omit, isEmpty, size, filter, orderBy, replace, head, keys } from 'lodash';
import { Divider, List } from 'antd';
import { FlexContainer, Row, Main, Column, Text, Icon, Button, FormInput, If, CompanyGroupsSelect, FormSelect, NotFound } from '../../common';
import { ANDROID_GREEN, ARGENT, GREEN_DARK, WHITE } from '../../../utils/colors';
import { withFirebase, withNavigation } from '../../../hoc';
import { withApollo } from 'react-apollo';
import ModalConfirmation from './ModalConfirmation';

const warning = {
    msg: 'El % de sustitución varía entre las tiendas',
    color: '#ECE285',
    iconNotification: 'caution',
    bgColor: '#FFFCE5',
    borderColor: '#ECE285'
};

const Substitutions = ({ firebase, session }) => {
    const sessionSalesChannel = orderBy(map(get(session, 'salesChannels'), ({ name, store, id, kind }) => ({ label: `${store} - ${name}`, value: id, kind })), ['label'], ['asc']);
    const [elementsOpened, setElementsOpened] = useState([]);
    const [loading, setLoading] = useState(false);
    const [substitutionType, setSubstitutionType] = useState('promotionPriceAboveType');
    const [elementsStorage, setElementsStorage] = useState({});
    const [companyGroup, setCompanyGroup] = useState({ label: 'Jumbo', value: 'Jumbo', isDefaultValue: true });
    const [salesChannel, setSalesChannel] = useState([]);
    const [priceAboveType, setPriceAboveType] = useState({});
    const [promotionPriceAboveType, setPromotionPriceAboveType] = useState({});
    const [allStores, setAllStores] = useState([]);
    const [globalSettingSubstitutions, setGlobalSettingSubstitutions] = useState({});
    const [allStoresFromFirebase, setAllStoresFromFirebase] = useState({});
    const [storeWithPercentageDiff, setStoreWithPercentageDiff] = useState({});
    const [visibleModal, setVisibleModal] = useState(false);
    const [paramElementIndex, setParamElementIndex] = useState(null);
    const [paramElementKey, setParamElementKey] = useState(null);
    const withPromotion = substitutionType === 'promotionPriceAboveType';
    const typePercentage = withPromotion ? 'promotionPriceAboveType' : 'priceAboveType';

    useEffect(() => {
        getStoreWithPercentageDiff();
    }, [allStoresFromFirebase]);

    useEffect(() => {
        getStoreWithPercentageDiff();
    }, [substitutionType]);

    const getPercentageByClientType = () => {
        if (size(salesChannel) > 1) {
            if (size(salesChannel) === 0) return {};
            const globalSettings = globalSettingSubstitutions[replace(get(companyGroup, 'value', '').toLowerCase(), /\s/g, '')];
            return get(globalSettings, typePercentage);
        }

        return withPromotion ? promotionPriceAboveType : priceAboveType;
    };

    const clientTypes = [
        {
            icon: 'prime',
            text: 'Prime',
            key: 'prime',
            percentage: get(getPercentageByClientType(), 'prime')
        },
        {
            icon: 'vip',
            text: 'VIP',
            key: 'vip',
            percentage: get(getPercentageByClientType(), 'vip')
        },
        {
            icon: 'colaborador',
            text: 'Normal',
            key: 'normal',
            percentage: get(getPercentageByClientType(), 'normal')
        }
    ];

    const getStoreWithPercentageDiff = () => {
        const allStoresFromFirebaseFilteredByGroup = filter(allStoresFromFirebase, { kind: get(companyGroup, 'value') });
        const globalSettings = globalSettingSubstitutions[get(companyGroup, 'value', '').toLowerCase()];
        const globalpercentage = get(globalSettings, typePercentage);

        const getStoreWithPercentageDiffToGlobalSetting = (type) => {
            return filter(allStoresFromFirebaseFilteredByGroup, (i) => {
                const percentageStore = get(i, typePercentage);
                return !(get(percentageStore, type) === get(globalpercentage, type));
            });
        };

        const storesWithPercentageDiffGroupedByClientType = {
            prime: getStoreWithPercentageDiffToGlobalSetting('prime'),
            vip: getStoreWithPercentageDiffToGlobalSetting('vip'),
            normal: getStoreWithPercentageDiffToGlobalSetting('normal')
        };

        setStoreWithPercentageDiff(storesWithPercentageDiffGroupedByClientType);
    };

    useEffect(() => {
        (async () => {
            await firebase.collection('config').doc('backoffice').onSnapshot(doc => {
                setGlobalSettingSubstitutions(get(doc.data(), 'global-setting-substitutions[0]', []));
                setPriceAboveType(priceAboveType);
                setPromotionPriceAboveType(promotionPriceAboveType);
            });

            firebase.collection('salesChannel').onSnapshot(docs => {
                let elements = [];

                docs.forEach(doc => {
                    if (doc.exists) {
                        const promotionPriceAboveType = get(doc.data(), 'promotionPriceAboveType');
                        const priceAboveType = get(doc.data(), 'priceAboveType');

                        elements.push({ id: doc.id, promotionPriceAboveType, priceAboveType });
                    }
                });

                const response = map(elements, (element) => {
                    return {
                        ...element,
                        ...head(filter(sessionSalesChannel, { value: get(element, 'id') }))
                    };
                });

                setAllStoresFromFirebase(response);
            });
        })();
    }, []);

    const onChangeSalesChannels = (value) => {
        isEmpty(allStores) && setAllStores(value);

        if (size(value) === 1) {
            const storeRef = firebase.collection('salesChannel').doc(value[0].value);

            storeRef.onSnapshot(storeDoc => {
                if (storeDoc.exists) {
                    setPriceAboveType(get(storeDoc.data(), 'priceAboveType', {}));
                    setPromotionPriceAboveType(get(storeDoc.data(), 'promotionPriceAboveType', {}));
                }
            });
        }

        if (size(value) === 0) {
            setPriceAboveType({});
            setPromotionPriceAboveType({});
        }

        const globalSettings = globalSettingSubstitutions[get(companyGroup, 'value', '').toLowerCase()];

        setPromotionPriceAboveType(get(globalSettings, 'promotionPriceAboveType', {}));
        setPriceAboveType(get(globalSettings, 'priceAboveType', {}));
        getStoreWithPercentageDiff();
    };

    const onClickSubstitutionType = (type) => {
        if (substitutionType === type) return null;

        return setSubstitutionType(type);
    };

    const onClickClientType = (type) => {
        return includes(elementsOpened, type)
            ? setElementsOpened(remove(elementsOpened, e => e !== type))
            : setElementsOpened(concat(elementsOpened, type));
    };

    const substitutionTypeTabs = [
        {
            key: 'promotionPriceAboveType',
            text: 'Con promoción'
        },
        {
            key: 'priceAboveType',
            text: 'Sin promoción'
        }
    ];

    const onChangeElementInput = (index, value) => {
        value >= 0 && setElementsStorage({ [index]: value });
    };

    const { msg, bgColor, iconNotification, color, borderColor } = warning;

    const onSaveChange = async (index, key) => {
        setLoading(true);
        const batch = firebase.batch();
        const fields = join(split(index, '-'), '.');
        const storeIds = map(salesChannel, 'value');

        try {
            if (size(salesChannel) > 1) {
                const docRef = firebase.collection('config').doc('backoffice');
                const settingByCompanyGroup = globalSettingSubstitutions[get(companyGroup, 'value', '').toLowerCase()];

                const newGlobalSettingSubstitutions = {
                    'global-setting-substitutions': [{
                        ...globalSettingSubstitutions,
                        [get(companyGroup, 'value', '').toLowerCase()]: {
                            ...settingByCompanyGroup,
                            [typePercentage]: {
                                ...settingByCompanyGroup[typePercentage],
                                [key]: get(elementsStorage, index, 0)
                            }
                        }
                    }]
                };

                docRef.update(newGlobalSettingSubstitutions)
                    .then(() => {
                        console.log('Configuración global actualizada correctamente.');
                        setLoading(false);
                        setVisibleModal(false);
                    })
                    .catch(error => {
                        console.error('Error al actualizar el Configuración global:', error);
                    });
            }

            Promise.all(
                storeIds.map(id => {
                    const storeRef = firebase.collection('salesChannel').doc(id);

                    return storeRef.get()
                        .then(storeDoc => {
                            storeDoc.exists && batch.update(storeRef, { [fields]: get(elementsStorage, index, 0) });
                        });
                })
            ).then(() => {
                batch.commit().then(() => {
                    setElementsStorage(omit(elementsStorage, index));
                    setLoading(false);
                    setVisibleModal(false);
                });
            });
        } catch (error) {
            console.log({ error });
        }
    };

    const salesChannelFilteredOptionsByKind = options => filter(options, ({ kind }) => get(companyGroup, 'value') === kind);

    useEffect(() => {
        getStoreWithPercentageDiff();
        if (!get(companyGroup, 'isDefaultValue')) {
            setSalesChannel(isEmpty(companyGroup) ? sessionSalesChannel : salesChannelFilteredOptionsByKind(sessionSalesChannel));
        }
    }, [companyGroup]);

    if (isEmpty(allStoresFromFirebase)) return null;

    const validateDisabledButton = (currentClientType) => {
        const clientType = split(keys(elementsStorage), '-')[1];

        return isEmpty(elementsStorage) && !(clientType === currentClientType);
    };

    const onCloseModal = () => setVisibleModal(false);

    const modal = (elementIndex, key) => {
        setParamElementKey(key);
        setParamElementIndex(elementIndex);
        setVisibleModal(true);
    };

    return (
        <Main background='f4f4f4' withFooter>
            <FlexContainer paddingHorizontal={23} paddingVertical={16}>
                <Row border='1px solid #eaeaea' borderRadius={3} padding='3px 13px' backgroundColor={WHITE}>
                    <Row gap={10}>
                        <Row>
                            <CompanyGroupsSelect
                                onChange={(value) => {
                                    !get(value, 'isDefaultValue') && setCompanyGroup(value);
                                }}
                                initialValue={{ label: 'Jumbo', value: 'Jumbo', isDefaultValue: true }}
                            />
                        </Row>
                        <Row>
                            <FormSelect
                                multiple
                                label='Tienda'
                                value={salesChannel}
                                options={salesChannelFilteredOptionsByKind(sessionSalesChannel)}
                                onChange={({ value }) => {
                                    setSalesChannel(value);
                                    onChangeSalesChannels(value);
                                }}
                            />
                        </Row>
                    </Row>
                    <FlexContainer justify='end' align='center' flex={1}>
                        <Button link text='Limpiar' width={112} right={10} />
                    </FlexContainer>
                </Row>
            </FlexContainer>
            {!(size(salesChannel) > 0)
                ? <NotFound
                    firstTextLine='Aún no se ha realizado una búsqueda, utiliza los filtros.'
                    icon='find'
                    backgroundColor='#F4F4F4'
                    iconBackgroundColor='#F4F4F4'
                    iconColor='#c0c0c0'
                    iconSize={85}
                    fontSize={20}
                    centered
                />
                : <>
                    <FlexContainer paddingHorizontal={23}>
                        <Row backgroundColor={WHITE}>
                            { map(substitutionTypeTabs, ({ key, text }) => (
                                <Column
                                    padding={4}
                                    align='center'
                                    borderBottom={substitutionType === key ? `3px solid ${ANDROID_GREEN}` : `1px solid ${ARGENT}`}
                                    key={key}
                                    onClick={() => onClickSubstitutionType(key)}
                                    pointer
                                >
                                    <Text text={text} strong />
                                </Column>
                            ))}
                        </Row>
                    </FlexContainer>
                    <FlexContainer paddingHorizontal={23} paddingVertical={16}>
                        <Row backgroundColor={WHITE}>
                            <Column paddingHorizontal={16} paddingVertical={8}>
                                {size(salesChannel) === 1
                                    ? <Text text={get(salesChannel, '[0].label')} color={GREEN_DARK} strong />
                                    : <Text text='Atención!, estás viendo los datos de varias salas' color={GREEN_DARK} strong />
                                }
                            </Column>
                        </Row>
                    </FlexContainer>
                    <FlexContainer direction='column' paddingHorizontal={50}>
                        { map(clientTypes, ({ icon, text, key, percentage = 0 }) => {
                            const elementIndex = `${substitutionType}-${key}`;
                            return (
                                <FlexContainer direction='column' boxShadow backgroundColor={WHITE} mB={8} borderRadius={3} key={icon}>
                                    <Row padding={16}>
                                        <Column justify='center' noFlex>
                                            <span style={{ fontSize: '24px', marginRight: '24px' }}>
                                                <span className={`icon-ic-tipo-${icon}`}>
                                                    <span className='path1' />
                                                    <span className='path2' />
                                                    <span className='path3' />
                                                </span>
                                            </span>
                                        </Column>
                                        <Column justify='center'>
                                            <Text text={text} strong />
                                        </Column>
                                        {!isEmpty(storeWithPercentageDiff[key]) && size(salesChannel) > 1 ? <Column justify='center' flex={3}>
                                            <Row align='center' style={{ backgroundColor: bgColor, border: `1px solid ${borderColor}`, borderRadius: 8, padding: '9px 12px', width: 350 }}>
                                                <Icon name={iconNotification} size={24} color={color} />
                                                <Divider type='vertical' style={{ background: color, height: '1.5em', margin: '0px 16px 0px 14px' }} />
                                                <Text text={msg} size={12} color='#323A44' strong />
                                            </Row>
                                        </Column>
                                        : <Column justify='center' flex={3}>
                                            <Text strong text={`${percentage}%`} size={20} />
                                        </Column>}
                                        <Column justify='center' align='end' noFlex width={55}>
                                            <Icon name='edit' size={23} color={GREEN_DARK} pointer onClick={() => onClickClientType(elementIndex)} />
                                        </Column>
                                    </Row>
                                    <If
                                        condition={includes(elementsOpened, elementIndex)}
                                        then={
                                            <FlexContainer padding={16} borderTop={`1px solid ${ARGENT}`}>
                                                <Column align='center' style={{ alignSelf: 'center' }}>
                                                    <Text text='Escoge un % de sustitución predeterminado para todas las tiendas.' />
                                                    <Row>
                                                        <Text text='% Sustitución' strong />
                                                        <FormInput
                                                            onChange={(value) => onChangeElementInput(elementIndex, get(value, 'target.value', null))}
                                                            value={get(elementsStorage, elementIndex, '')}
                                                            placeholder={`${getPercentageByClientType()[key]}%`}
                                                        />
                                                    </Row>
                                                    <Button text='Guardar cambios' width={204} onClick={() => size(salesChannel) > 1 ? modal(elementIndex, key) : onSaveChange(elementIndex, key)} disabled={validateDisabledButton(key)} loading={loading} />
                                                </Column>
                                                {!isEmpty(storeWithPercentageDiff[key]) && size(salesChannel) > 1 && <Column align='center' style={{ alignSelf: 'center' }}>
                                                    <List
                                                        style={{ height: 250, width: '90%', padding: '0px 40px', boxShadow: '0px 2px 4px 0px #00000026', overflow: 'auto' }}
                                                        header={<Row gap={10}>
                                                            <Icon name='caution' color='#ECE285' size={18} />
                                                            <Text text='Variación entre tiendas' strong />
                                                        </Row>}
                                                        itemLayout='horizontal'
                                                        dataSource={storeWithPercentageDiff[key]}
                                                        renderItem={(item) => {
                                                            const percentage = get(item, typePercentage);
                                                            return <List.Item>
                                                                <List.Item.Meta description={get(item, 'label')} />
                                                                <Text text={`${get(percentage, key, '0')}%`} color={GREEN_DARK} strong />
                                                            </List.Item>;
                                                        }}
                                                    />
                                                </Column>}
                                            </FlexContainer>
                                        }
                                    />
                                </FlexContainer>
                            );
                        }) }
                    </FlexContainer>
                </>
            }
            {visibleModal && <ModalConfirmation
                visible={visibleModal}
                onClose={onCloseModal}
                updateSustitutions={() => onSaveChange(paramElementIndex, paramElementKey)}
                loading={loading}
            />}
        </Main>
    );
};

Substitutions.propTypes = {
    session: object,
    firebase: object
};

export default withApollo(withFirebase(withNavigation(Substitutions)));
